export default __webpack_public_path__ + "dfcb8c356f80dc36cb9e12d7054b0215.svg";